import { AlertTriangle } from "lucide-react";
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ProductDeleteDialog = ({ open, onOpenChange, impact, busy, error, onConfirm }) => {
  const products = impact?.client_products || [];
  const count = impact?.client_product_count || 0;
  return (
    <AlertDialog open={open} onOpenChange={value => { if (!busy) onOpenChange(value); }}>
      <AlertDialogContent className="max-h-[90vh] overflow-y-auto rounded-sm" data-testid="delete-confirm-modal">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 text-[#8C3A3A] mb-1">
            <AlertTriangle className="w-5 h-5 shrink-0" aria-hidden="true" />
            <AlertDialogTitle className="font-serif text-xl text-[#1A1A1A]" data-testid="delete-product-title">
              Eliminare {impact?.name || "il prodotto"}?
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-sm leading-relaxed" data-testid="delete-product-warning">
            {count > 0
              ? `Questa azione eliminerà definitivamente il prodotto e ${count} ${count === 1 ? "prodotto creato per un cliente" : "prodotti creati per i clienti"}. I clienti e gli altri loro prodotti resteranno intatti.`
              : "Questa azione è irreversibile. Verranno eliminati anche ingredienti, foto ed etichette collegate."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {count > 0 && (
          <div className="mt-2" data-testid="delete-linked-products">
            <p className="text-xs uppercase tracking-wide text-[#707070] mb-2" data-testid="delete-linked-count">
              Prodotti cliente coinvolti: {count}
            </p>
            <ul className="max-h-44 overflow-y-auto border border-[#E5E5E0] divide-y divide-[#E5E5E0]">
              {products.map(cp => (
                <li key={cp.id} className="px-3 py-2 text-sm break-words" data-testid={`delete-linked-product-${cp.id}`}>
                  <span className="font-medium" data-testid={`delete-linked-client-${cp.id}`}>{cp.client_name}</span>
                  <span className="text-[#707070]"> — {cp.code ? `${cp.code} · ` : ""}{cp.name}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        {error && <p role="alert" className="text-xs text-[#8C3A3A]" data-testid="delete-product-error">{error}</p>}
        <AlertDialogFooter className="gap-2 mt-3">
          <AlertDialogCancel disabled={busy} data-testid="delete-cancel-btn">Annulla</AlertDialogCancel>
          <button type="button" onClick={onConfirm} disabled={busy}
                  className="btn-primary bg-[#8C3A3A] border-[#8C3A3A] disabled:opacity-50"
                  data-testid="delete-confirm-btn">
            {busy ? "Eliminazione..." : count > 0 ? "Elimina prodotto e collegamenti" : "Elimina prodotto"}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};